import { render, staticRenderFns } from "./outOfStockRecordQuery.vue?vue&type=template&id=56f368eb&scoped=true"
import script from "./outOfStockRecordQuery.vue?vue&type=script&lang=js"
export * from "./outOfStockRecordQuery.vue?vue&type=script&lang=js"
import style0 from "./outOfStockRecordQuery.vue?vue&type=style&index=0&id=56f368eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f368eb",
  null
  
)

export default component.exports